// Connected container — renders `RelationshipRow` children which each fetch on
// demand. Not storyable (transitively needs QueryClient).

import { ChevronDown } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import type { RelationshipGroup } from '@/features/document-overlay/grouping'
import { RelationshipChip } from './RelationshipChip'
import { RelationshipRow } from './RelationshipRow'

export function RelationshipAccordion({
  caseId,
  group,
}: {
  caseId: string
  group: RelationshipGroup
}) {
  const [open, setOpen] = useState(false)
  const { t } = useTranslation()
  const notShown = group.total - group.relationships.length
  return (
    <div
      style={{
        borderRadius: '12px',
        border: `1px solid ${open ? 'var(--primary)' : 'var(--border)'}`,
        background: open ? 'var(--accent)' : 'var(--card)',
        overflow: 'hidden',
        transition: 'border-color 0.16s ease, background 0.16s ease',
      }}
    >
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        aria-expanded={open}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          width: '100%',
          padding: '10px 12px',
          background: 'transparent',
          border: 'none',
          color: 'var(--foreground)',
          fontFamily: 'inherit',
          cursor: 'pointer',
          textAlign: 'left',
        }}
      >
        <ChevronDown
          size={13}
          style={{
            color: 'var(--muted-foreground)',
            transform: open ? 'rotate(0deg)' : 'rotate(-90deg)',
            transition: 'transform 0.18s ease',
            flexShrink: 0,
          }}
        />
        <RelationshipChip>{group.type}</RelationshipChip>
        <span style={{ flex: 1 }} />
        <span
          style={{
            fontSize: 12,
            color: 'var(--foreground)',
            fontFamily: 'var(--font-mono)',
            fontVariantNumeric: 'tabular-nums',
          }}
        >
          {group.total}
        </span>
      </button>
      {open && (
        <div
          style={{
            borderTop: '1px solid var(--border)',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {group.relationships.map(r => (
            <RelationshipRow key={r.id} caseId={caseId} rel={r} />
          ))}
          {notShown > 0 && (
            <div
              style={{
                padding: '8px 12px',
                fontSize: 11,
                color: 'var(--muted-foreground)',
                fontStyle: 'italic',
              }}
            >
              {t('documents.detail.moreNotShown', { count: notShown })}
            </div>
          )}
        </div>
      )}
    </div>
  )
}
